import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Drawer, DatePicker } from "antd";

import { create as CreateCareUnitDatesRange } from "../../api/CareUnitDatesRange.js";
import { update as UpdateCareUnitDatesRange } from "../../api/CareUnitDatesRange.js";

import moment from "moment";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3"
  },
};

const CareUnitDatesRangeForm = (props) => {
  const { careUnit } = props;
  const { careUnitDatesRange } = props;
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async () => {
    let values = form.getFieldsValue();

    values.start_at = values['range'][0]
      .startOf("day")
      .toISOString(true);

    values.end_at = values['range'][1]
      .startOf("day")
      .toISOString(true);

      values.care_unit_id = careUnit.id;

    delete values.range;

    if (careUnitDatesRange) {
      await UpdateCareUnitDatesRange(careUnitDatesRange.id, values);
    } else {
      await CreateCareUnitDatesRange(values);
    }

    props.onCreated();
    onClose();
  };

  const onFinishFailed = (errorInfo) => {
    // @todo a implementé
    console.log("Failed:", errorInfo);
  };

  const onClose = () => {
    props.onClose();
    form.resetFields();
  };

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  let initialValues = {
    range: [moment(), moment()],
    description: null,
    daily_bed_capacity: 45,
    daily_occupancy_rate: 25,
  };

  useEffect(() => {
    if (careUnitDatesRange) {
      form.setFieldsValue({
        range: [moment(careUnitDatesRange.start_at), moment(careUnitDatesRange.end_at)],
        description: careUnitDatesRange.description,
        daily_bed_capacity: careUnitDatesRange.daily_bed_capacity,
        daily_occupancy_rate: careUnitDatesRange.daily_occupancy_rate,
      });
    } else if(careUnit) {
      form.setFieldsValue({
        range: [moment(), moment()],
        daily_bed_capacity: careUnit.daily_bed_capacity,
        daily_occupancy_rate: careUnit.daily_occupancy_rate,
      });
    }
  }, [careUnit, careUnitDatesRange]);

  let drawerTitle = "Ajout d'une nouvelle date de configuration";
  if (careUnitDatesRange) {
    drawerTitle = "Modification d'une date de configuration";
  }

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width="800px"
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button onClick={onFinish} type="primary">
            Enregistrer
          </Button>
        </div>
      }
    >
      <Form
        {...layout}
        form={form}
        name="care_unit"
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >

        <Form.Item label="Dates" name="range">
          <RangePicker />
        </Form.Item>
        <Form.Item label="Nombre de lits" name="daily_bed_capacity">
          <InputNumber />
        </Form.Item>
        <Form.Item label="Taux d'occupation non-programmée anticipé" name="daily_occupancy_rate">
          <InputNumber
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace("%", "")}
          />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea rows={4} className="ant-input-text" />
        </Form.Item>
      </Form> 
    </Drawer>
  );
};

export default CareUnitDatesRangeForm;
